import React from 'react';
import PropTypes from 'prop-types';

const EstimateView = ({
  estimate,
  creditEstimate,
  loadingEstimate,
  onPayAndTranslate,
  onTranslate,
}) => {
  if (!creditEstimate) return null;

  const {
    cost,
    old_credit,
    balance_credit,
    need_to_pay,
    can_translate_without_payment,
  } = creditEstimate;

  return (
    <div className="h-full flex items-center justify-center">
      <div className="mt-4 text-center text-gray-800 flex items-center justify-center">
        <div className="bg-white p-5 rounded-lg flex flex-col items-center justify-center">
          {can_translate_without_payment ? (
            <>
              <p className="text-2xl text-pl_prim_color_1">
                Cost: Rs. {cost}
                <br />
                <span className="text-2xl text-pl_prim_color_1">(consumed in credits)</span>
              </p>
              <br />
              <button
                className="bg-pl_prim_color_1 text-white px-8 py-2 rounded-full hover:bg-pl_prim_color_2 flex items-center justify-center mx-auto"
                onClick={() => onTranslate()}
                disabled={loadingEstimate}
              >
                Translate
              </button>
            </>
          ) : (
            <>
              <p className="text-xl mb-2">Word count: {estimate?.word_count}</p>
              <p className="text-xl mb-2">Per word rate: Rs. {estimate?.per_word_rate}</p>
              <p className="text-2xl text-pl_prim_color_1 mb-2">Cost: Rs. {cost}</p>

              {old_credit > 0 ? (
                <p className="text-lg text-red-500 mb-2">
                  Insufficient credit. Need to pay: Rs. {need_to_pay}
                </p>
              ) : null}

              <button
                className="bg-pl_prim_color_1 text-white px-8 py-2 rounded-full hover:bg-pl_prim_color_2 flex items-center justify-center mx-auto"
                onClick={onPayAndTranslate}
                disabled={loadingEstimate}
              >
                Pay and translate
              </button>
            </>
          )}

          
          <br />
          <p className="text-lg mb-6">
            Note: Translation will take roughly {estimate?.estimated_time} minutes. You can wait here till it finishes, check back later, or close this tab. We will email the translated document to you.
          </p>
        </div>
      </div>
    </div>
  );
};

EstimateView.propTypes = {
  estimate: PropTypes.object,
  creditEstimate: PropTypes.object,
  loadingEstimate: PropTypes.bool,
  onPayAndTranslate: PropTypes.func,
  onTranslate: PropTypes.func,
  estimated_time: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default EstimateView;
